import { token } from '@zillow/constellation';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  position: relative;
  max-width: 768px;
  margin: 0 auto;
  width: 100%;
  border-bottom: 1px solid ${token('colors.gray300')};
  min-height: 80px;
  justify-content: center;
  align-items: center;
  display: flex;
`;
